var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fpc_corner-box"},[(_vm.pageType === 'left')?_c('div',{staticClass:"fpc_page-tip",on:{"click":_vm.prev}},[_vm._m(0)]):_c('div',{staticClass:"fpc_page-tip",on:{"click":_vm.next}},[_vm._m(1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fpc_corner-contents"},[_c('div',{staticClass:"fpc_corner-button"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fpc_corner-contents"},[_c('div',{staticClass:"fpc_corner-button"})])
}]

export { render, staticRenderFns }